export default {
    api: {
        host: 'localhost'
    }
};


// WEBPACK FOOTER //
// ./src/configuration/config_local.js